$(document).on('change', '#region_default_promo_code_id', function() {
  var request_origin_id = $(this).find(':selected').attr('data-request-origin-id')
  $('#region_default_request_origin_id').val(request_origin_id).trigger('chosen:updated')
})

$(document).on('change', '#region_default_request_origin_id', function() {
  $('#region_default_promo_code_id').val('').trigger('chosen:updated')
})
